import React, { Component } from 'react'
import '../components/navbar.css'
import { Link } from 'react-scroll';

export class Navbar extends Component {

  state = {clicked:false};
  handleClicked = () =>{
    this.setState({ clicked: !this.state.clicked })
  }

  handleLinkClick = () => {
    this.setState({ clicked: false });
  };

  render() {
    return (
      <nav className='NavbarItems'>
        <h1 className='navbar-logo'>Shrimad Bhagvat Geeta</h1>

      <div className='menu-icons' onClick={this.handleClicked}>
        <i className={this.state.clicked ? 'fas fa-times' : 'fas fa-bars'}></i>
      </div>

        <ul className={this.state.clicked ? "nav-menu active" : "nav-menu"}> 
          <li>
          <Link to="home" onClick={this.handleLinkClick} smooth={true}  duration={100} className='nav-link'>
            <i class="fa-solid fa-house-user"></i>Home
          </Link>
          </li>

          <li>
          <Link to="about" onClick={this.handleLinkClick} smooth={true} duration={100} className='nav-link'>
            <i class="fa-solid fa-circle-info"></i>About
          </Link>
          </li>

          <li>
          <Link to="contact" onClick={this.handleLinkClick} smooth={true} duration={100} className='nav-link'>
            <i class="fa-solid fa-address-book"></i>Contact
          </Link>
          </li>

          <li>
          <Link to="chaptes" onClick={this.handleLinkClick} smooth={true} duration={100} className='nav-link'>
          <i class="fa-solid fa-circle-arrow-right"></i>Chapters
          </Link>
          </li>
          
        </ul>

      </nav>
    )
  }
}

export default Navbar
